import { toFormData } from "@/app/shared/utils/helpers";
import httpManager from "@/app/shared/utils/httpManager";

export async function importMasiveProcessTemplate(payload) {
  const response = await httpManager.upload("/imports/massive-process/", toFormData(payload));
  return response?.data;
}
